import React from 'react';
import Styled from './Logo.style';
import { Link } from 'react-router-dom';
import { renderCdnUrl } from '../../helpers';
import _ from 'lodash';

interface LogoProps {
  user: any;
  swsmLocation: any;
  availableRewards: any;
}

const Logo: React.FC<LogoProps> = props => {
  const { swsmLocation, user, availableRewards } = props;
  const rewards = _.get(availableRewards, 'data.bannerIds.length');

  const logoRewards = _.get(user, 'data.branding.logoURL');

  const renderLogo = () => {
    if (availableRewards && logoRewards) {
      return <img src={logoRewards} alt="Logo" style={{ maxHeight: '70px' }} />;
    }
    else if (user.data && rewards === 0 && user.data.has_custom_logo) {
      return <img src={renderCdnUrl(`logos/${user.data.waterClient}-color.svg`)} alt="Logo" />;
    }
    else if (swsmLocation.data) {
      return <img src={renderCdnUrl(`logos/${swsmLocation.data.logo_slug}-color.svg`)} alt="Logo" />;
    }
    return <img src={renderCdnUrl('logos/www-color.svg')} alt="Logo" />;
  };

  return (
    <Styled.Logo>
      <Styled.Logo>
        <Link to="/">{renderLogo()}</Link>
      </Styled.Logo>
    </Styled.Logo>
  );
};

export default Logo;
